import { zh_cn } from './zh_cn';


export const messages = {
	'zh-cn': zh_cn
};
